import type { CustomerPaymentMethods } from "~/shared/schemas/invoice-schema.ts";
import type {
	PaymentNonce,
	SavedAch,
	SavedCard,
} from "~/shared/types/payment-types.ts";

import { SavedACHAccount } from "../saved-ach-account/saved-ach-account.tsx";
import { SavedCCCard } from "../saved-cc-card/saved-cc-card.tsx";

export const DisplaySavedPaymentMethods = ({
	handleApplyPaymentMethod,
	selectedMethod,
	selectedPayment,
	accounts,
	isLoadingAccounts,
}: {
	handleApplyPaymentMethod: (
		paymentMethod: SavedCard | SavedAch | PaymentNonce,
	) => void;
	selectedMethod: "ACH" | "CreditCard" | null;
	selectedPayment: SavedCard | SavedAch | PaymentNonce | null;
	accounts: CustomerPaymentMethods | null | undefined;
	isLoadingAccounts: boolean;
}) => {
	if (isLoadingAccounts) {
		return <div>Loading saved payment methods...</div>;
	}

	const paymentAccounts = accounts?.paymentAccounts ?? [];

	return (
		<div>
			<h4>Previous Payment Methods</h4>
			{selectedMethod === "CreditCard"
				? paymentAccounts
						.filter((account) => account.paymentMethod === "CreditCard")
						.map((card) => (
							<SavedCCCard
								key={`saved-card-${card.paymentMethodToken}`}
								handleApplyPaymentMethod={handleApplyPaymentMethod}
								isSelected={
									!!(
										selectedPayment &&
										"paymentMethodToken" in selectedPayment &&
										card.paymentMethodToken ===
											selectedPayment.paymentMethodToken
									)
								}
								savedCard={card}
							/>
						))
				: paymentAccounts
						.filter((account) => account.paymentMethod === "ACH")
						.map((ach) => (
							<SavedACHAccount
								key={`saved-ach-${ach.paymentMethodToken}`}
								handleApplyPaymentMethod={handleApplyPaymentMethod}
								isSelected={
									!!(
										selectedPayment &&
										"paymentMethodToken" in selectedPayment &&
										ach.paymentMethodToken ===
											selectedPayment.paymentMethodToken
									)
								}
								savedAch={ach}
							/>
						))}
		</div>
	);
};
